<template>
  <base-button
    :class="{ active: value }"
    :aria-controls="controls"
    :collapse="collapse"
    aria-expanded="false"
    class="button-option"
    data-toggle="collapse"
    @click="toggle">{{ text }}</base-button>
</template>

<script>
export default {
  name: 'ButtonOption',

  props: {
    collapse: String,
    controls: String,
    selected: { default: 'Selected', type: String },
    unselected: { default: 'Select', type: String },
    value: Boolean
  },

  computed: {
    text () {
      return this.value ? this.selected : this.unselected
    }
  },

  methods: {
    toggle () {
      this.$emit('input', !this.value)
    }
  }
}
</script>
